import { useEffect, useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import './Header.css';

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const isMobile = useMediaQuery({ maxWidth: 600 });

  // close menu when resizing to desktop
  useEffect(() => {
    if (!isMobile) setMenuOpen(false);
  }, [isMobile]);

  return (
    <header className={`header ${isMobile ? 'mobile' : ''} ${menuOpen ? 'open' : ''}`}>
      {isMobile && (
        <button
          className="menu-toggle"
          aria-label="Toggle navigation"
          onClick={() => setMenuOpen((o) => !o)}
        >
          ☰
        </button>
      )}

      <nav className="nav-left" onClick={() => isMobile && setMenuOpen(false)}>
        <a href="/home" className="nav-link">HOME</a>
        <a href="/film" className="nav-link">FILM</a>
        <a href="/games" className="nav-link">GAMES</a>
      </nav>

      <div className="logo-container">
        <img src="/soundtrackarchive.png" alt="Soundtrack Archive" className="logo" />
      </div>

      {!isMobile && (
        <nav className="nav-right" onClick={() => setMenuOpen(false)}>
          <a href="https://www.darkspacepub.com/privacy-policy" className="nav-link">PRIVACY</a>
          <a href="https://www.darkspacepub.com/cookies-policy" className="nav-link">COOKIES</a>
          <a href="https://www.darkspacepub.com/terms" className="nav-link">TERMS</a>
        </nav>
      )}
    </header>
  );
}

export default Header;
